module.exports = __webpack_public_path__ + "static/media/1005452.06fda85e.jpg";